import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';

import { ConfigService } from '../../services/config.service';
import { SessionService } from '../../services/session.service';
import { SocketService } from '../../services/socket.service';
import { RxComponent } from '../common/rx.component';

declare var $: any;

@Component({
    selector: 'itpx-inbox',
    templateUrl: './inbox.component.html',
    styleUrls: ['./inbox.component.css']
})
export class InboxComponent extends RxComponent implements OnInit {

    private unreadMessagesInboxAmount: any;
    private unreadAccountMessagesAmount: any;
    private unreadMessagesArchivedAmount: any;
    private unreadAccountMessagesArchivedAmount: any;
    private refresh = new Subject<boolean>();
    private messagesListUrl: string;
    private messagesArchivedListUrl: string;
    private userDomain: String;
    private tab: string;

    constructor(
        private router: Router,
        private configService: ConfigService,
        private sessionService: SessionService,
        private socketService: SocketService,
        private route: ActivatedRoute
    ) {
        super();
        this.userDomain = this.sessionService.getUserDomain();
        this.messagesListUrl = this.configService.get('server').url + this.configService.get('endpoints').sahara.conversation.list.api;
        this.messagesArchivedListUrl = this.configService.get('server').url + this.configService.get('endpoints').sahara.conversation.listArchived.api;
    }

    ngOnInit() {
        this.socketService.onNotification()
            .bindToLifecycle(this)
            .subscribe(_ => {
                this.refresh.next(true);
            }, err => console.log(err));

        this.route.queryParams
            .map(params => params['tab'])
            .filter(tab => tab)
            .bindToLifecycle(this)
            .subscribe(tab => {
                this.tab = tab;
            });
    };

    ngOnDestroy() { };

    private onTabClick(e) {
        let tabId = e.srcElement.attributes['href'].value;
        this.router.navigate(
            ['/inbox'],
            { queryParams: { tab: tabId.substr(1) } }
        );
    }

    private onSizeNewInboxChanged(e: number) {
        this.unreadMessagesInboxAmount = e;
    }

    private onSizeNewArchivedChanged(e: number) {
        this.unreadMessagesArchivedAmount = e;
    }
    private onSizeNewMessageChanged(e: number) {
        this.unreadAccountMessagesAmount = e;
    }
    private onSizeArchivedMessageChanged(e: number) {
        this.unreadAccountMessagesArchivedAmount = e;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/inbox/inbox.component.ts